// If anything throws while drawing, a card with a reload button instead of a
// blank page (2 Nov 2026: a translated page crashed the sign-in to white).
import { Component, type ReactNode } from 'react';
import { S } from '../lib/strings';
import { Wordmark } from './Wordmark';

export class Crash extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error) { console.error('MyGaz Ops crashed', error); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="entry">
        <header className="entry-top"><div className="entry-brand"><img src="./mygaz-icon.png" alt="" /><Wordmark /><span className="tag">Ops</span></div></header>
        <section className="entry-center">
          <div className="entry-card">
            <div className="entry-step">
              <span className="entry-eyebrow r">MyGaz Ops</span>
              <h1>{S.crash.title}</h1><p>{S.crash.sub}</p>
              <button className="btn go" onClick={() => location.reload()}>{S.crash.reload}</button>
            </div>
          </div>
        </section>
        <footer className="entry-foot" />
      </main>
    );
  }
}
